export const PAGES_SLUG = {
  about: '/ve-chung-toi',
  contact: '/lien-he',
  search: '/tim-kiem',
  career: '/tuyen-dung',
  editorial_process: '/chinh-sach-bien-tap',
  advertising_policy: '/chinh-sach-quang-cao',
  privacy_policy: '/chinh-sach-bao-mat',
}
